/* GAI Collection Filter + Sort JS */
(function(){
'use strict';

// SORT
var sortEl = document.getElementById('gcpSort');
if(sortEl){
  sortEl.addEventListener('change', function(){
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', this.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
}

// FILTER CHECKBOXES — each checkbox navigates to its URL
document.querySelectorAll('.gcp-fi input[type=checkbox]').forEach(function(cb){
  cb.addEventListener('change', function(){
    var url = this.getAttribute('data-url-add') || this.getAttribute('data-url-remove');
    if(this.checked){
      url = this.getAttribute('data-url-add');
    } else {
      url = this.getAttribute('data-url-remove');
    }
    if(url) window.location.href = url;
  });
});

// PRICE FILTER
var priceApply = document.querySelectorAll('.gcp-pa');
priceApply.forEach(function(btn){
  btn.addEventListener('click', function(){
    var u = new URL(window.location.href);
    var minEl = document.getElementById('gcpMin') || btn.closest('.gcp-fv').querySelector('input:first-child');
    var maxEl = document.getElementById('gcpMax') || btn.closest('.gcp-fv').querySelector('input:last-of-type');
    var minName = btn.getAttribute('data-min-param');
    var maxName = btn.getAttribute('data-max-param');
    if(!minName || !maxName) return;
    var mn = minEl ? minEl.value : '';
    var mx = maxEl ? maxEl.value : '';
    if(mn) u.searchParams.set(minName, Math.round(parseFloat(mn)*100));
    else u.searchParams.delete(minName);
    if(mx) u.searchParams.set(maxName, Math.round(parseFloat(mx)*100));
    else u.searchParams.delete(maxName);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
});

// FILTER GROUP TOGGLE
document.querySelectorAll('.gcp-fgh').forEach(function(hdr){
  hdr.addEventListener('click', function(){
    this.parentNode.classList.toggle('collapsed');
  });
});

// MOBILE DRAWER
var filterBtn = document.querySelector('.gcp-filter-btn');
var drawer = document.getElementById('gcpDrawer');
var dov = drawer ? drawer.querySelector('.gcp-dov') : null;
var closeBtn = drawer ? drawer.querySelector('.gcp-dhead button') : null;
if(filterBtn && drawer){
  filterBtn.addEventListener('click', function(){
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}
if(dov){
  dov.addEventListener('click', function(){
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  });
}
if(closeBtn){
  closeBtn.addEventListener('click', function(){
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  });
}

})();
